import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './user-group.types';

export const userGroupSelectors = {
  ...generateResourceSelectors<types.IUserGroup>((state) => state.resource.userGroup),
};
